import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    addMidSession : [],
    loading : false,
    error : null,
};

const addMidSessionSlice = createSlice({
    name:"addMidSession",
    initialState,
    reducers: {
        fetchAddMidSessionSuccess: (state,action) => {
            state.loading = false;
            state.addMidSession = action.payload;
        },
        fetchAddMidSessionFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    },
})

export const {
    fetchAddMidSessionSuccess,
    fetchAddMidSessionFailure
} = addMidSessionSlice.actions

export default addMidSessionSlice.reducer